// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'

Vue.config.productionTip = false
Vue.use(VueMaterial)

Vue.material.registerTheme('default', {
  primary : {
    color : 'Indigo',
    hue : '400'
  },
  accent : {
    color : 'grey',
    hue : 300
  }
})

/* eslint-disable no-new */
new Vue({
  el : '#app',
  components : {App},
  template : '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js